import { useEffect, useState } from 'react';
import { twMerge } from 'tailwind-merge';

const tileColours = [
  'bg-blue-600',
  'bg-indigo-500',
  'bg-violet-500',
  'bg-emerald-600',
  'bg-amber-500',
  'bg-rose-500',
  'bg-cyan-600',
  'bg-slate-600',
];

const initialsOf = (name: string): string => {
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (!words.length) return '?';
  return words
    .slice(0, 2)
    .map((word) => word[0])
    .join('')
    .toUpperCase();
};

const colourOf = (name: string): string => {
  const charCodeSum = [...name].reduce(
    (sum, char) => sum + char.charCodeAt(0),
    0
  );
  return tileColours[charCodeSum % tileColours.length];
};

export interface EntityTileProps {
  name: string;
  imageSrc?: string | null;
  size?: 'sm' | 'md';
  className?: string;
}

export function EntityTile({
  name,
  imageSrc,
  size = 'md',
  className,
}: EntityTileProps) {
  const [hasImageError, setHasImageError] = useState(false);

  useEffect(() => {
    setHasImageError(false);
  }, [imageSrc]);

  const sizeClasses = size === 'sm' ? 'h-8 w-8 text-xs' : 'h-10 w-10 text-sm';

  if (imageSrc && !hasImageError) {
    return (
      <img
        src={imageSrc}
        alt={name}
        onError={() => setHasImageError(true)}
        className={twMerge(
          `${sizeClasses} shrink-0 rounded-lg border border-gray-200 bg-gray-50 object-cover`,
          className
        )}
      />
    );
  }

  return (
    <div
      aria-hidden='true'
      className={twMerge(
        `${sizeClasses} flex shrink-0 items-center justify-center rounded-lg font-inter font-semibold text-white ${colourOf(
          name
        )}`,
        className
      )}
    >
      {initialsOf(name)}
    </div>
  );
}
